import { entitySelectors } from '@store/entity/selectors';
import { changeJourneyParam } from '@store/yourJourney/actions';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { connect } from 'react-redux';
import { SpaDaysCategory } from './SpaDaysCategory';
import { bindActionCreators } from 'redux';
import { DispatchProps } from './SpaDaysCategory.types';

const mapStateToProps = (state) => {
  const journeyParams = yourJourneySelectors.getParsedJourneyParams(state);

  return {
    property: entitySelectors.getProperty(state),
    journeyParams,
  };
};

const mapDispatchToProps = (dispatch): DispatchProps =>
  bindActionCreators(
    {
      changeJourneyParam,
    },
    dispatch
  );

export const SpaDaysCategoryContainer: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(SpaDaysCategory);
